import React from 'react'
import { Field, reduxForm } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import { FormButtons, validations, renderers } from '../../components'

let ResetPasswordForm = ({
  dispatch,
  handleSubmit,
  pristine,
  reset,
  submitting,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="uid"
        type="password"
        component={renderers.renderHiddenField}
        label="Password"
        validate={[validations.required]}
      />
      <Field
        name="token"
        type="token"
        component={renderers.renderHiddenField}
        label="Password"
        validate={[validations.required]}
      />
      <Field
        name="new_password1"
        type="password"
        component={renderers.renderField}
        label="Password"
        validate={[validations.required]}
      />
      <Field
        name="new_password2"
        type="password"
        component={renderers.renderField}
        label="Confirm Password"
        validate={[validations.required]}
      />

      <ReactBootstrap.Col md={12} xs={12} lg={12}>
        <FormButtons
          submitting={submitting}
          pristine={pristine}
          reset={reset}
        />
      </ReactBootstrap.Col>
    </form>
  )
}
ResetPasswordForm = reduxForm({
  form: 'ResetPasswordForm',
})(ResetPasswordForm)

export default ResetPasswordForm
